import React from 'react'

import './whytv.css';

const WhyTv = () => {

    
    
  return (
    <section className="why-tv">
            <h2>Why choose CloseSellerTV?</h2>

            <ol type='1'>
            <li><span className='question-num'>1.</span>
            <span className='question-tit'>Targeted Advertising:</span>
                 We understand that reaching the right audience is crucial for the success of any advertising
                 campaign. Our team of experts will work closely with 
                you to identify your target market and create tailored adverts that resonate with your audience.
                </li>
                
                <li><span className='question-num'>2.</span>
                <span className='question-tit'>Creative Excellence:</span>
                 Our team of experienced creatives will bring your vision to life.
                 From concept development to production, we will ensure that your adverts are visually stunning
                  and deliver your brand message effectively.
                </li>

                <li><span className='question-num'>3.</span>
                <span className='question-tit'>Cost-Effective Solutions:</span>
                 We believe that effective advertising shouldn't break the bank.
                 Our pricing plans are designed to cater to businesses of all sizes, offering you the best 
                 value for your investment.s
                </li>

                <li><span className='question-num'>4.</span>
                <span className='question-tit'>Performance Tracking:</span> We provide detailed analytics and reports to track the performance of your 
                adverts. This data will help you make informed decisions and optimize your future campaigns for 
                even better results.
                </li>
            </ol>

            <p>
            So, what are you waiting for? Take your business to the next level with CloseSellerTV Advert Promotion
             Service. Contact us today to discuss your advertising goals and let us create a customized solution just 
             for you. Get ready to witness a surge in brand visibility, customer engagement, and ultimately, sales!
            </p>
        </section>
  )
}

export default WhyTv